var _ = require('underscore/underscore');
var BasePopup = require('front/components/BasePopup/BasePopup');

var template = require('./PerspectivePopup.jinja');
require('./PerspectivePopup.less');

var CommonStory = require('front/components/CommonStory/CommonStory');
var CommonSidebar = require('front/components/CommonSidebar/CommonSidebar');

module.exports = BasePopup.extend({

    template: template,

    //Base creates an instances for each one of found dom nodes (by selector) when parent view is rendered itself
    VIEWS_TO_REGISTER: {
        'CommonStory': {selector: '.CommonStory', viewConstructor: CommonStory},
        'CommonSidebar': {selector: '.CommonSidebar', viewConstructor: CommonSidebar}
    },

    events: _.extend({
        'click .PerspectivePopup-footer-moreLink': 'onMoreLinkClick'

    }, BasePopup.prototype.baseEvents),


    apiUrl: function () {
        var id = parseInt(this.slug.split('-')[0], 10);

        return Urls['front:api:perspective-popup'](id, 'json');
    },

    renderData: function () {
        return {
            popup: this.data || {}
        };
    },

    initialize: function (options) {
        this.options = options || {};

        this.slug = this.options.slug;

        BasePopup.prototype.initialize.call(this, options);
    },


    onMoreLinkClick: function (e) {
        var $link = $(e.currentTarget);
        var hash = $link.attr('data-hash');

        //important to explicitly set perspective url, for cases when perspacetive popup opened from index, or search results page
        Backbone.history.navigate(Urls['front:perspective'](), {trigger: 'true'});

        if (hash) {
            setTimeout(function () {
                location.hash = hash;
            }, 500);
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/pages/PerspectivePopup/PerspectivePopup.js
// module id = 287
// module chunks = 0